import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M330 20L330 98 670 98 670 20ZM70 260L180 260 180 894Q180 935 202 957.5 224 980 266 980L734 980Q775 980 797.5 957.5 820 935 820 894L820 260 930 260 930 182 70 182ZM349 808L349 354 427 354 427 808ZM573 808L573 354 651 354 651 808Z" })
});
export default SvgDelete;
